import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes, RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from '@core/strategies/custom-route-reuse.strategy';
import { AUTH_RC, AUTHORIZED_RC, NOT_FOUND_RC, TERMS_AND_CONDITION_RC } from '@core/constants/routes.constants';
import { PreloadingStrategyService } from '@core/services/preloading-strategy.service';
import { AuthGuard } from '@core/guards/auth.guard';
import { IntakeSurveyGuard } from '@core/guards/intake-survey.guard';
import { DefaultRouteGuard } from '@core/guards/default-route.guard';

const routes: Routes = [
  {
    path: TERMS_AND_CONDITION_RC.root,
    loadComponent: () =>
      import('@features/terms-and-condition/terms-and-condition/terms-and-condition.component').then(
        (m) => m.TermsAndConditionComponent
      ),
  },
  {
    path: AUTH_RC.root,
    loadChildren: () => import('@features/auth/auth.module').then((m) => m.AuthModule),
    canMatch: [() => inject(AuthGuard).canMatchUnauthorized()],
  },
  {
    path: AUTHORIZED_RC.root,
    loadChildren: () =>
      import('@features/authorized-content/authorized-content.module').then((m) => m.AuthorizedContentModule),
    canMatch: [() => inject(AuthGuard).canMatchAuthorized()],
    canActivate: [IntakeSurveyGuard, DefaultRouteGuard],
  },
  {
    path: NOT_FOUND_RC.root,
    loadChildren: () => import('@features/not-found/not-found.module').then((m) => m.NotFoundModule),
  },
  { path: '**', redirectTo: NOT_FOUND_RC.root, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadingStrategyService })],
  exports: [RouterModule],
  providers: [{ provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy }],
})
export class AppRoutingModule {}
